//Formiks
import { useField } from "formik"
import FormikCheckBox from "../../../../../helpers/formikInputs/FormikCheckboxInput"
import FormikNumberInput from "../../../../../helpers/formikInputs/FormikNumberInput"

//Styles
import myStyles from "../../../../../styles/assessments/ManagementFormBuilder.module.css"
import assessStyles from "../../../../../styles/assessments/Assessment.module.css"

export default function QuestionDateOptions({ formikQuestionName, disabled }) {
  const verifyAgeFormikName = `${formikQuestionName}.verifyAge`

  const [verifyAgeField, ,] = useField(verifyAgeFormikName)

  return (
    <>
      <div className={assessStyles.switchControl}>
        <FormikCheckBox
          name={verifyAgeFormikName}
          label={"Age verification"}
          helpText={
            "Prevent users under a certain age from submitting this form"
          }
          useSwitch={true}
          disabled={disabled}
        />
      </div>
      <span className={myStyles.numberContainer}>
        <FormikNumberInput
          name={`${formikQuestionName}.minAge`}
          label={"Minimum age"}
          minFractionDigits={0}
          showButtons
          disabled={!verifyAgeField.value || disabled}
        />
      </span>
      <div className={assessStyles.switchControl}>
        <FormikCheckBox
          name={`${formikQuestionName}.allowFutureDates`}
          label={"Allow future dates"}
          helpText={"Allow users to select dates after their current date"}
          useSwitch={true}
          disabled={disabled}
        />
        <FormikCheckBox
          name={`${formikQuestionName}.allowPastDates`}
          label={"Allow past dates"}
          helpText={"Allow users to select dates before their current date"}
          useSwitch={true}
          disabled={disabled}
        />
      </div>
    </>
  )
}
